export enum MlhChallenges {
    MLH_CHALLENGE_1 = 'Best Use of ElevenLabs - Custom Apple Airpods',
    MLH_CHALLENGE_2 = 'Best Use of Gemini API - Wireless Headphones',
    MLH_CHALLENGE_3 = 'Best Use of MongoDB Atlas - Google Swag Kits',
    MLH_CHALLENGE_4 = 'Best Use of DigitalOcean - M5GO starter kit',
    MLH_CHALLENGE_5 = 'Best Use of Solana - Retro Wireless Mouse',
    MLH_CHALLENGE_6 = 'Best Use of Auth0 - Ledger Nano S Plus',
}

export default MlhChallenges;